import {
  NumberInput,
  required,
  SaveButton,
  SelectInput,
  TextInput,
  SimpleForm,
  useTranslate,
  BooleanInput,
} from 'react-admin';
import { Box, Stack, Typography } from '@mui/material';
import { AmountRange, RedPacketType } from '../../../services/redpacketService';

interface FormProps {
  isCreate: boolean;
  typeFilter: RedPacketType;
  record?: AmountRange;
}

const TypeConfigForm = (props: FormProps) => {
  const { isCreate, typeFilter, record } = props;
  const t = useTranslate();

  const numberProps = {
    parse: (v: any) => (v === '' || v == null ? undefined : Number(v)),
    format: (v: any) => (v == null ? '' : v),
    inputProps: {
      inputMode: 'decimal',
      step: 'any',
      onWheel: (e: React.WheelEvent<HTMLInputElement>) => {
        (e.currentTarget as HTMLInputElement).blur();
      },
    } as const,
  } as const;

  return (
    <Stack spacing={3} gap={2}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        spacing={2}
        mb={1}
      >
        <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
          {t('module.redpacket.redPacketType')}
        </Typography>
        <Box sx={{ flexGrow: 1 }}>
          <SelectInput
            source="redPacketType"
            label={false}
            choices={[
              { id: RedPacketType.TWITTER_BINDING, name: 'TWITTER_BINDING' },
              { id: RedPacketType.TWITTER_FOLLOW, name: 'TWITTER_FOLLOW' },
              { id: RedPacketType.DEPOSIT, name: 'DEPOSIT' },
              { id: RedPacketType.TRADING, name: 'TRADING' },
              { id: RedPacketType.CRITICAL_HIT, name: 'CRITICAL_HIT' },
            ]}
            validate={[required()]}
            fullWidth
            defaultValue={typeFilter}
            disabled={!isCreate}
          />
        </Box>
      </Stack>

      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        spacing={2}
        mb={1}
      >
        <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
          {t('module.redpacket.minAmount')}
        </Typography>
        <Box sx={{ flexGrow: 1 }}>
          <NumberInput
            label={false}
            source="minAmount"
            validate={[required()]}
            placeholder={t('module.redpacket.minAmountPlaceholder')}
            fullWidth
            defaultValue={record?.minAmount}
            {...numberProps}
          />
        </Box>
      </Stack>

      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        spacing={2}
        mb={1}
      >
        <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
          {t('module.redpacket.maxAmount')}
        </Typography>
        <Box sx={{ flexGrow: 1 }}>
          <NumberInput
            label={false}
            source="maxAmount"
            validate={[required()]}
            placeholder={t('module.redpacket.maxAmountPlaceholder')}
            fullWidth
            defaultValue={record?.maxAmount}
            {...numberProps}
          />
        </Box>
      </Stack>

      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        spacing={2}
        mb={1}
      >
        <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
          {t('module.redpacket.skewFactor')}
        </Typography>
        <Box sx={{ flexGrow: 1 }}>
          <NumberInput
            label={false}
            source="skewFactor"
            placeholder={t('module.redpacket.skewFactorPlaceholder')}
            fullWidth
            defaultValue={record?.skewFactor}
            {...numberProps}
          />
        </Box>
      </Stack>

      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        spacing={2}
        mb={1}
      >
        <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
          {t('module.redpacket.description')}
        </Typography>
        <Box sx={{ flexGrow: 1 }}>
          <TextInput
            label={false}
            source="description"
            placeholder={t('module.redpacket.descriptionOptional')}
            fullWidth
            multiline
            defaultValue={record?.description}
            rows={3}
          />
        </Box>
      </Stack>

      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        spacing={2}
        mb={1}
      >
        <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
          {t('module.banners.isActive')}
        </Typography>
        <Box sx={{ flexGrow: 1 }}>
          <BooleanInput
            label=""
            source="isActive"
            helperText={<span style={{ color: 'red' }}>{''}</span>}
            defaultValue={record?.isActive}
          />
        </Box>
      </Stack>
    </Stack>
  );
};

export default TypeConfigForm;
